/**
 * Pure, dependency-free production-build mode guard.
 *
 * This module is deliberately framework-agnostic: it contains NO `import.meta`
 * usage and NO browser/Vite-only globals, so it can be imported from BOTH the
 * browser runtime (via `config.ts`) AND the Node build pipeline (`vite.config.ts`).
 * That dual import is what lets us fail a mock-mode production bundle at BUILD
 * time (vite exits non-zero before `dist/` is produced) in addition to the
 * belt-and-suspenders runtime guard.
 *
 * A PROD bundle that does not resolve both lanes to `live` is almost always a
 * misconfigured deploy: the 2026-06-10 incident shipped mock fixtures under the
 * production host, and it recurred on 2026-06-14 when a bare `npm run build`
 * defaulted both modes to `mock` and the runtime guard then blanked
 * coaching.vjal.ai. The guard fails fast unless an operator opts in with
 * `VITE_ALLOW_MOCK_BUILD=1`.
 */
export function guardProductionMode({
  prod,
  authMode,
  dataMode,
  allowMock
}: {
  prod: boolean;
  authMode: string;
  dataMode: string;
  allowMock: boolean;
}): { ok: boolean; reason?: string } {
  if (!prod) return { ok: true };
  if (allowMock) return { ok: true };
  if (authMode === "live" && dataMode === "live") return { ok: true };
  return {
    ok: false,
    reason: `Production build requires VITE_AUTH_MODE=live and VITE_DATA_MODE=live (got authMode=${authMode}, dataMode=${dataMode}). Set both, or set VITE_ALLOW_MOCK_BUILD=1 to ship an intentional mock bundle.`
  };
}
